module.exports = __webpack_public_path__ + "static/logo-one-global-b788e19a31a0955356f732942984cd08.svg";